// extracted by mini-css-extract-plugin
export default {"wrapper":"ToggleButton-module__wrapper","isActive":"ToggleButton-module__isActive","button":"ToggleButton-module__button"};